import styled from 'styled-components';
import { Label } from 'reactstrap';

const StyledLabel = styled(Label)`
  font-family: ${props => props.theme.fontFamily};
  color: ${props =>
    props.error ? props.theme.colors.red : props.theme.colors.black};
  font-weight: bold;
  text-transform: uppercase;
  font-size: 0.8em;
  margin-bottom: 0.3em;

  &:after {
    content: ${props => (props.required ? "'*'" : '')};
    color: #f00;
    margin-left: 0.125em;
  }
`;

export default StyledLabel;
